import React, { useState, useRef, useEffect } from "react";
import "./registration.scss";
import API from "@src/api/backend/registration";
import { Row, Col, Button, Input, Table, Select, message, Modal, Tooltip } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { loadingDesktop } from "@src/redux/loading";
import { getFactories } from "@src/redux/auth";
import FactoryClass from "@src/models/factory";
import { lang, COMMON_CONSTANT } from "@src/constants/common.const";
// import { openPopupDesktop } from "@src/redux/confirm";
import BoxContent from "@src/component/Desktop/content";
import {
  CloudDownloadOutlined,
  ClearOutlined,
  CloudUploadOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import TitlePage from "../../component/Desktop/titlePage";
const { Option } = Select;
function NewInventoryRegistration() {
  const columns = [
    {
      title: lang.NAME_SHEET,
      dataIndex: "SheetName",
      width: "30%",
      align: "center",
    },
    {
      title: lang.NUMBER_ROW,
      dataIndex: "RowNum",
      width: "20%",
      align: "center",
    },
    {
      title: lang.MESSAGE,
      dataIndex: "ErrorMessage",
      width: "50%",
      align: "left",
      render: (text) => {
    if (!text) return <span></span>; 

    return (
      <>
        {text.split('\n').map((line, idx) => (
          <React.Fragment key={idx}>
            {line}
            {idx !== text.split('\n').length - 1 && <br />}
          </React.Fragment>
        ))}
      </>
    );
    },
    },
  ];
  const dispatch = useDispatch();
  const inputFile = useRef(null);
  const [data, updateData] = useState([]);
  const [nameFile, updateNameFile] = useState(null);
  const [dataFileReader, updateFileReader] = useState(null);
  const [factory, updateFactory] = useState(null);
  const [importName, setImportName] = useState("IMPORT_FACILITY");
  const [factoryName, updateFactoryName] = useState(null);
  const { factories, selectedFactory, selectedFactoryName } = useSelector((state) => state.auth);
  useEffect(() => {
    dispatch(getFactories());
  }, [dispatch]);
  const uploadFile = () => {
    clearFile();
    inputFile.current.click();
  };
  const clearFile = () => {
    updateFileReader(null);
    updateNameFile(null);
    inputFile.current.value = null;
  };
  const onImportExcel = (file) => {
    updateFileReader(null);
    // Get the uploaded file object
    const { files } = file.target;
    updateNameFile(files[0]);
    // Read the file through the FileReader object
    if (files[0]) {
      const fileReader = new FileReader();
      // Open the file in base64 mode
      fileReader.readAsDataURL(files[0]);
      updateFileReader(fileReader);
    }
  };
  const callGetStatus = (id, isFirstCall) => {
    if (isFirstCall) {
      API.checkNewStatus(id, isFirstCall);
    }
    setTimeout(function () {
      API.checkNewStatus(id)
        .then((statusImport) => {
          if (statusImport && statusImport.status === 200) {
            switch (Number(statusImport.data.status)) {
              case 0:
                callGetStatus(id);
                break;
              case 1:
                dispatch(loadingDesktop(false));
                Modal.success({
                  centered: true,
                  title: (
                    <span style={{ fontWeight: "bold" }}>{lang.SUCCESS}</span>
                  ),
                  content: COMMON_CONSTANT.BOM_C002,
                  okText: lang.OK,
                });
                updateData(null);
                break;
              case 2:
                dispatch(loadingDesktop(false));
                Modal.error({
                  centered: true,
                  title: (
                    <span style={{ fontWeight: "bold" }}>{lang.ERROR}</span>
                  ),
                  content: "取込ファイルにエラーが発生しました。",
                  okText: lang.OK,
                });
                updateData(JSON.parse(statusImport.data.content));
                break;
              default:
                break;
            }
          }
        })
        .catch((error) => {
          dispatch(loadingDesktop(false));
          Modal.error({
            centered: true,
            title: <span style={{ fontWeight: "bold" }}>{lang.ERROR}</span>,
            content: "取込ファイルにエラーが発生しました。",
            okText: lang.OK,
          });
        });
    }, 1000);
  };
  // download file
  const downloadFileInventory = async () => {
    dispatch(loadingDesktop(true));
    try {
      const res = await API.exportNewInventory(selectedFactory,importName);
      dispatch(loadingDesktop(false));
      const disposition = res.headers['content-disposition'];
      let filename = "downloaded_file.xlsx";

      if (disposition) {
        const matches = disposition.match(/filename=([^;]+)/);
        if (matches && matches[1]) {
          filename = decodeURIComponent(matches[1].replace(/['"]/g, '').trim());
        }
      }
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const a = document.createElement("a");
      a.href = url;
      a.setAttribute("download", filename);

      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      dispatch(loadingDesktop(false));
    }
  };


  const importInventory = () => {
    if (dataFileReader) {
      dispatch(loadingDesktop(true));
      API.importNewInventory({
        ImportType: importName,
        FileData: dataFileReader.result,
        FileName: nameFile.name,
        SiteOfficeMasterCode: selectedFactory,
        SiteOfficeMasterName: selectedFactoryName,
      })
        .then((res) => {
          if (res && res.status === 200) {
            callGetStatus(res.data, true);
          } else {
            Modal.error({
              centered: true,
              title: <span style={{ fontWeight: "bold" }}>{lang.ERROR}</span>,
              content: "取込ファイルにエラーが発生しました。",
              okText: lang.OK,
            });
          }
        })
        .catch((error) => {
          dispatch(loadingDesktop(false));
          if (error.response) {
            let arrMessage = error.response.data;
            Modal.error({
              centered: true,
              title: <span style={{ fontWeight: "bold" }}>{lang.ERROR}</span>,
              content: arrMessage.msg,
              okText: lang.OK,
            });
          }
        });
    } else {
      message.error("取り込みファイルを選択してください。");
    }
  };
  // render option select

  const { Option } = Select;
  return (
    <div className="des-content">
      <TitlePage name={lang.IMPORT_NEW_MACHINE} />
      <BoxContent>
        <Row gutter={[32, 32]} className="rowNotMargin">
          <Col span={24}>
            <Row gutter={[16, 0]} align="middle" justify="center">
              <Col span={5} className="text-end">
                <Button
                  className="buttonPC button--info"
                  onClick={uploadFile}
                  icon={<UploadOutlined />}
                >
                  {lang.SELECT_FILE}
                </Button>
              </Col>
              <Col span={11}>
                <Input
                  type="text"
                  disabled
                  value={nameFile ? nameFile.name : ""}
                  suffix={
                    <ClearOutlined
                      onClick={clearFile}
                      style={{ color: "red" }}
                    />
                  }
                />
                <input
                  type="file"
                  hidden
                  accept=".xlsx, .xls"
                  onChange={onImportExcel}
                  ref={inputFile}
                />
              </Col>
            </Row>
            <Row
              gutter={[16, 0]}
              align="middle"
              justify="center"
              style={{ paddingTop: "16px" }}
            >
              <Col className="titleText text-end" span={5}>
                {lang.NAME_OFFICE_SITE}
              </Col>
              <Col span={11}>
                <Input
                  style={{ width: "100%" }}
                  value={"由仁"}
                  disabled
                />
              </Col>
            </Row>

            <Row
              gutter={[16, 0]}
              align="middle"
              justify="center"
              style={{ paddingTop: "16px" }}
            >
              <Col className="titleText text-end" span={5}>
                {"テンプレート名"}
              </Col>
              <Col span={11}>
                <Select
                  style={{ width: "100%" }}
                  defaultValue="IMPORT_FACILITY"
                  value={importName}
                  onChange={setImportName}
                >
                  <Option value="IMPORT_FACILITY">施設台帳取込様式</Option>
                  <Option value="IMPORT_MACHINE">設備台帳取込様式</Option>
                </Select>
              </Col>
            </Row>
          </Col>

          <Col span={24}>
            <h3 style={{ fontWeight: "bold" }}>エラー箇所</h3>
            <Table
              className="gridSearch"
              columns={columns}
              dataSource={data}
              pagination={{ position: ["bottomCenter"], pageSize: 10 }}
            />
          </Col>
          <Col span={24}>
            <Row className="rowNotMargin" gutter={[12, 0]}>
              <Col flex="auto" />
              <Col flex="none">
                <Tooltip title="すでに登録された内容を反映したインポートファイルを出力します。">
                  <Button
                    className="buttonPC button--outline --todo-- wAuto"
                    onClick={downloadFileInventory}
                    icon={
                      <CloudDownloadOutlined
                        style={{
                          color: "#f50",
                        }}
                      />
                    }
                  >
                    インポートファイル出力
                  </Button>
                </Tooltip>
              </Col>
              <Col flex="none" style={{ paddingRight: 0 }}>
                <Button
                  className="buttonPC button--info"
                  onClick={importInventory}
                  icon={<CloudUploadOutlined />}
                >
                  {lang.REGISTRY}
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
      </BoxContent>
    </div>
  );
}

export default NewInventoryRegistration;
